import { styled } from '@clickcease/cc-client-components-lib'

export const BundleStyled = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'relative',
})

export const BundlesContent = styled('div', {
  display: 'flex',
  flexDirection: 'column',
})

export const BundlesStepFlexRow = styled('div', {
  display: 'flex',
  justifyContent: 'center',
})

export const BundlesStepWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '90%',
})

export const BundlesStepContent = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',

  '@bp1': {
    '&:nth-child(2)': {
      marginTop: '$24',
    },
  },
})

export const BundlesStepTitleWrapper = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
})

export const BundlesStepTitle = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  fontWeight: '$sb',
  fontSize: '$hxl',
  margin: '18px 0px 24px 0px',

  '@bp1': {
    margin: '0px 0px 8px 0px',
  },
})

export const BundlesStepTitleCurrency = styled('div', {
  marginTop: '$10',
  paddingInline: '13px',
  display: 'flex',
  justifyContent: 'flex-end',
})

export const BundlesPlansAndCurrentPlanWrapper = styled('div', {
  display: 'flex',
  justifyContent: 'center',
})

export const BundlesStepTitleBold = styled('div', {
  fontWeight: '$b',
})

export const BundlesUpToWrapper = styled('div', {
  display: 'flex',
  fontSize: '$h2',
  marginBottom: '$8',
})

export const BundlesStepNumber = styled('div', {
  fontSize: '$h2',
  fontWeight: '$sb',
})

export const BundlesSelectVisitsText = styled('div', {
  fontSize: '$lg',
  fontWeight: '$b',
  width: '90%',
})

export const BundlesStepUpToBold = styled('div', {
  fontWeight: '$sb',
  color: '$primaryColor',
  margin: '0px $2 0px $2',
})

export const BundlesPlanWrapper = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: '40px',

  '> div': {
    marginRight: '10px',

    '&:last-child': {
      marginRight: '0px',
    },
  },

  '@bp1': {
    marginTop: '$5',
    justifyContent: 'center',
    flexDirection: 'column',
  },
})

export const BundlePricingPlanMobile = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
})

export const BundlesFeaturesShowHide = styled('div', {
  display: 'flex',
  margin: '64px 0px 64px 0px',
  width: '1126px',

  '@bp1': {
    justifyContent: 'center',
    width: '100%',
  },
})

export const BundleShowHideFeaturesList = styled('div', {
  color: '$primaryColor',
  fontSize: '$h4',
  fontWeight: '$sb',

  cursor: 'pointer',
})

export const ToggleWithTextWrapper = styled('div', {
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  marginBottom: '50px',
})

export const BundleSliderWrapper = styled('div', {
  position: 'relative',

  '@bp1': { position: 'relative', width: '100%', height: '100px', overflow: 'hidden' },
})

export const BundlesPickPlan = styled('div', {
  fontSize: '$lg',
  fontWeight: '$b',
  margin: '$5 0px $10 0px',
})
